// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import { reduxForm, Field, formValueSelector } from "redux-form";
import validate from "../validate";
import currentFormTypes from "../../../../common/components/CurrentFormTypes";
import { switchCase } from "../../../../common/services/utils";
import {
    RenderTextField,
    RenderRadioGroup,
    RenderRadio,
    RenderCheckboxField,
} from "../../../../common/components/FormFields";

import { Button, Paper } from "@material-ui/core";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import globalsCss from "../../../../common/styles/globals.css";
import formsCss from "../../../../common/styles/forms.css";
import { USER_TYPE_STANDARD, USER_TYPE_MANAGER, USER_TYPE_ADMIN } from "../values";
import { connect } from "react-redux";
import { FormatTime } from "@/common/components/Time";

const StatusItem = ({ currentFormType, status }) =>
    switchCase({
        // eslint-disable-next-line react/display-name
        [currentFormTypes.EDIT]: () => {
            return (
                <div className="col-xs-12" css={formsCss.blockedRadioButtons}>
                    <Field name="status" component={RenderRadioGroup} row>
                        <RenderRadio
                            disabled={status === "pending" || status === "inactive"}
                            value="active"
                            label="Active"
                            className="col-lg-2 col-sm-3 col-xs-12"
                        />
                        <RenderRadio
                            disabled={status === "pending" || status === "inactive"}
                            value="blocked"
                            label="Blocked"
                            className="col-lg-2 col-sm-3 col-xs-12"
                        />
                        <RenderRadio
                            disabled={true}
                            value="pending"
                            label="Pending"
                            className="col-lg-2 col-sm-3 col-xs-12"
                        />
                        <RenderRadio
                            disabled={true}
                            value="inactive"
                            label="Inactive"
                            className="col-lg-2 col-sm-3 col-xs-12"
                        />
                    </Field>
                    <hr />
                </div>
            );
        },
        [currentFormTypes.NEW]: () => null,
    })(() => null)(currentFormType)();

class Form extends Component {
    componentDidMount() {
        this.props.initialize(this.props.initialValues); // here add this line to initialize the form
    }

    render() {
        const {
            error,
            submitting,
            handleSubmit,
            currentFormType,
            initialValues,
            push,
            errors,
            selectedPermissionLevel,
        } = this.props;

        return (
            <Paper elevation={1}>
                <div css={globalsCss.inner}>
                    <h2 css={globalsCss.subtitleTitle}>
                        {currentFormType === "NEW" ? "Add new LSE Staff" : "Edit LSE Staff"}
                    </h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <StatusItem
                                status={initialValues.status}
                                {...{ currentFormType, initialValues }}
                            />
                            <div className="col-sm-4 col-xs-12">
                                <Field
                                    name="email"
                                    errorRes={errors.email}
                                    type="email"
                                    component={RenderTextField}
                                    label="LSE Email"
                                    fullWidth
                                    /*
                                    // once user is created, afterwards we map user by playref so can freely edit email address
                                    disabled={
                                        initialValues.id && initialValues.status !== "pending"
                                            ? true
                                            : false
                                    }
                                    */
                                />
                            </div>

                            <div className="col-sm-4 col-xs-12">
                                <Field
                                    name="firstName"
                                    errorRes={errors.firstName}
                                    type="firstName"
                                    component={RenderTextField}
                                    label="First Name"
                                    fullWidth
                                />
                            </div>
                            <div className="col-sm-4 col-xs-12">
                                <Field
                                    name="lastName"
                                    errorRes={errors.lastName}
                                    type="lastName"
                                    component={RenderTextField}
                                    label="Last Name"
                                    fullWidth
                                />
                                <Field
                                    name="lastNameLocked"
                                    errorRes={errors.lastNameLocked}
                                    label="Locked"
                                    component={RenderCheckboxField}
                                />
                            </div>

                            {initialValues.playRef && (
                                <div className="col-sm-4 col-xs-12">
                                    <div css={formsCss.item}>
                                        <div css={formsCss.itemLabel}>Playref</div>
                                        <div css={formsCss.itemValue}>{initialValues.playRef}</div>
                                    </div>
                                </div>
                            )}
                            {initialValues.lseStaff && initialValues.lseStaff.jobTitle && (
                                <div className="col-sm-4 col-xs-12">
                                    <div css={formsCss.item}>
                                        <div css={formsCss.itemLabel}>Job Title</div>
                                        <div css={formsCss.itemValue}>
                                            {initialValues.lseStaff.jobTitle}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {initialValues.lseStaff && initialValues.lseStaff.departmentCode && (
                                <div className="col-sm-4 col-xs-12">
                                    <div css={formsCss.item}>
                                        <div css={formsCss.itemLabel}>Department</div>
                                        <div css={formsCss.itemValue}>
                                            {initialValues.lseStaff.departmentName
                                                ? `${initialValues.lseStaff.departmentName} (${initialValues.lseStaff.departmentCode})`
                                                : `${initialValues.lseStaff.departmentCode}`}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {initialValues.lastLoginAt && (
                                <div className="col-sm-4 col-xs-12">
                                    <div css={formsCss.item}>
                                        <div css={formsCss.itemLabel}>Last login</div>
                                        <div css={formsCss.itemValue}>
                                            <FormatTime
                                                date={initialValues.lastLoginAt}
                                                format="dddd D MMMM YYYY h.mma"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <hr />
                        <label
                            css={[formsCss.label, globalsCss.helpers.mt20]}
                            htmlFor="permissionLevel"
                        >
                            Permission Level
                        </label>
                        <div>
                            <Field
                                name="permissionLevel"
                                errorRes={errors.permissionLevel}
                                component={RenderRadioGroup}
                                row
                            >
                                <RenderRadio
                                    value={USER_TYPE_STANDARD}
                                    label="Standard"
                                    className="col-lg-2 col-sm-3 col-xs-12"
                                />
                                <RenderRadio
                                    value={USER_TYPE_MANAGER}
                                    label="Manager"
                                    className="col-lg-2 col-sm-3 col-xs-12"
                                />
                                <RenderRadio
                                    value={USER_TYPE_ADMIN}
                                    label="Admin"
                                    className="col-lg-2 col-sm-3 col-xs-12"
                                />
                            </Field>
                        </div>

                        {(selectedPermissionLevel === USER_TYPE_STANDARD ||
                            selectedPermissionLevel === USER_TYPE_MANAGER) && (
                            <div>
                                <hr />
                                <label
                                    css={[formsCss.label, globalsCss.helpers.mt20]}
                                    htmlFor="hasBookings"
                                >
                                    Can hold office hours?
                                </label>
                                <div>
                                    <Field
                                        name="hasBookings"
                                        errorRes={errors.hasBookings}
                                        component={RenderRadioGroup}
                                        row
                                    >
                                        <RenderRadio
                                            value={"Y"}
                                            label="Yes"
                                            className="col-lg-2 col-sm-3 col-xs-12"
                                        />
                                        <RenderRadio
                                            value={"N"}
                                            label="No"
                                            className="col-lg-2 col-sm-3 col-xs-12"
                                        />
                                    </Field>
                                </div>
                            </div>
                        )}

                        {selectedPermissionLevel === USER_TYPE_MANAGER && (
                            <div>
                                <hr />
                                <label
                                    css={[formsCss.label, globalsCss.helpers.mt20]}
                                    htmlFor="canManageStandardNotifications"
                                >
                                    Can manage notifications?
                                </label>
                                <div>
                                    <Field
                                        name="canManageStandardNotifications"
                                        label="Standard notifications"
                                        component={RenderCheckboxField}
                                        errorRes={errors && errors.allowFileUpload}
                                    />
                                    <Field
                                        name="canManageTimetableNotifications"
                                        label="Timetable notifications"
                                        component={RenderCheckboxField}
                                        errorRes={errors && errors.allowFileUpload}
                                    />
                                </div>
                            </div>
                        )}
                        {error && <strong>{error}</strong>}
                        <div css={formsCss.actions}>
                            <Button
                                disabled={submitting}
                                type="submit"
                                variant="contained"
                                color="primary"
                                css={formsCss.btnSubmit}
                            >
                                Submit
                            </Button>
                            <Button
                                disabled={submitting}
                                onClick={() => push("/users-and-audiences/lse-staff")}
                                css={formsCss.btnBack}
                            >
                                Back to the list
                            </Button>
                        </div>
                    </form>
                </div>
            </Paper>
        );
    }
}

const FORM_NAME = "Staff";

const form = reduxForm({
    form: FORM_NAME,
    validate,
    enableReinitialize: true,
})(Form);

const selector = formValueSelector(FORM_NAME);

const mapStateToProps = ({ form }) => ({
    selectedPermissionLevel: selector({ form }, "permissionLevel"),
});

export default connect(mapStateToProps, null)(form);
